export default __webpack_public_path__ + "static/media/cardiac-risk.6bcf2185.svg";